import axios from 'axios'
import { supabase } from './supabaseClient'

const API = process.env.NODE_ENV === 'development' ? "http://localhost:8080/api" : "/api"

const apiClient = axios.create({ baseURL: API })

apiClient.interceptors.request.use(async (config) => {
    const { data: { session } } = await supabase.auth.getSession()
    if (session?.access_token) {
        config.headers.Authorization = `Bearer ${session.access_token}`
    }
    return config
})

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            supabase.auth.signOut()
            window.location.href = '/login'
        }
        return Promise.reject(error)
    }
)

export default apiClient
